<template>
<svg
    class="mobile-nav-icon"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
>
    <g v-if="name === 'home'">
        <path
            v-if="filled"
            fill="currentColor"
            stroke="none"
            d="M12 2.6 2.5 10.75v9.5c0 .55.45 1 1 1h5.35v-6.2h6.3v6.2h5.35c.55 0 1-.45 1-1v-9.5L12 2.6Z"
        />
        <path
            v-else
            d="m3.2 10.8 8.8-7.5 8.8 7.5v9.1a1.1 1.1 0 0 1-1.1 1.1h-4.8v-6.2H9.1V21H4.3a1.1 1.1 0 0 1-1.1-1.1v-9.1Z"
        />
    </g>

    <g v-else-if="name === 'catalog'">
        <template v-if="filled">
            <rect x="2.75" y="2.75" width="8.25" height="8.25" rx="2" fill="currentColor" stroke="none"/>
            <rect x="13" y="2.75" width="8.25" height="8.25" rx="2" fill="currentColor" stroke="none"/>
            <rect x="2.75" y="13" width="8.25" height="8.25" rx="2" fill="currentColor" stroke="none"/>
            <rect x="13" y="13" width="8.25" height="8.25" rx="2" fill="currentColor" stroke="none"/>
        </template>
        <template v-else>
            <rect x="3.25" y="3.25" width="7.25" height="7.25" rx="1.7"/>
            <rect x="13.5" y="3.25" width="7.25" height="7.25" rx="1.7"/>
            <rect x="3.25" y="13.5" width="7.25" height="7.25" rx="1.7"/>
            <rect x="13.5" y="13.5" width="7.25" height="7.25" rx="1.7"/>
        </template>
    </g>

    <g v-else-if="name === 'library'">
        <path
            v-if="filled"
            fill="currentColor"
            stroke="none"
            d="M6.25 2.5h11.5A2.25 2.25 0 0 1 20 4.75v16.7a.55.55 0 0 1-.84.47L12 17.52l-7.16 4.4A.55.55 0 0 1 4 21.45V4.75A2.25 2.25 0 0 1 6.25 2.5Z"
        />
        <path
            v-else
            d="M6.25 3.25h11.5c.83 0 1.5.67 1.5 1.5v15.8L12 16.1l-7.25 4.45V4.75c0-.83.67-1.5 1.5-1.5Z"
        />
    </g>

    <g v-else-if="name === 'search'">
        <template v-if="filled">
            <path
                fill="currentColor"
                stroke="none"
                fill-rule="evenodd"
                d="M10.5 2.5a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm0 3a5 5 0 1 0 0 10 5 5 0 0 0 0-10Z"
            />
            <path d="m16.2 16.2 4.35 4.35" stroke-width="3"/>
        </template>
        <template v-else>
            <circle cx="10.5" cy="10.5" r="7"/>
            <path d="m15.7 15.7 4.8 4.8"/>
        </template>
    </g>

    <g v-else-if="name === 'schedule'">
        <path
            v-if="filled"
            fill="currentColor"
            stroke="none"
            d="M7 2a1 1 0 0 1 1 1v1h8V3a1 1 0 1 1 2 0v1h.25A3.75 3.75 0 0 1 22 7.75v10.5A3.75 3.75 0 0 1 18.25 22H5.75A3.75 3.75 0 0 1 2 18.25V7.75A3.75 3.75 0 0 1 5.75 4H6V3a1 1 0 0 1 1-1Zm-3 8v8.25C4 19.22 4.78 20 5.75 20h12.5c.97 0 1.75-.78 1.75-1.75V10H4Z"
        />
        <template v-else>
            <rect x="3" y="4.5" width="18" height="17" rx="3"/>
            <path d="M7 2.5v4M17 2.5v4M3 9.5h18"/>
        </template>
    </g>

    <g v-else-if="name === 'settings'">
        <circle cx="12" cy="12" r="3"/>
        <path d="M19.4 15a1.7 1.7 0 0 0 .34 1.88l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.7 1.7 0 0 0-1.88-.34 1.7 1.7 0 0 0-1.03 1.56V21a2 2 0 1 1-4 0v-.09A1.7 1.7 0 0 0 9 19.36a1.7 1.7 0 0 0-1.88.34l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.7 1.7 0 0 0 4.63 15a1.7 1.7 0 0 0-1.56-1H3a2 2 0 1 1 0-4h.09A1.7 1.7 0 0 0 4.64 9a1.7 1.7 0 0 0-.34-1.88l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.7 1.7 0 0 0 9 4.63h.01A1.7 1.7 0 0 0 10 3.09V3a2 2 0 1 1 4 0v.09A1.7 1.7 0 0 0 15 4.64a1.7 1.7 0 0 0 1.88-.34l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.7 1.7 0 0 0 19.37 9v.01A1.7 1.7 0 0 0 20.91 10H21a2 2 0 1 1 0 4h-.09A1.7 1.7 0 0 0 19.4 15Z"/>
    </g>
</svg>
</template>

<script>
const ICON_NAMES = ['home', 'catalog', 'library', 'search', 'schedule', 'settings']

export default {
    name: 'MobileNavIcon',
    props: {
        name: {
            type: String,
            required: true,
            validator: (value) => ICON_NAMES.includes(value),
        },
        filled: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style scoped>
.mobile-nav-icon {
    display: block;
    flex: 0 0 22px;
    width: 22px;
    height: 22px;
    overflow: visible;
    fill: none;
    stroke: currentColor;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
    pointer-events: none;
}
</style>
